import React from 'react';
import { Typography, Box, useTheme } from "@mui/material";
import Grid from '@mui/material/Grid2';

const EntityMessagesDetails = ({ messages, overviewScreen = false }) => {
    const theme = useTheme();

    if (!messages || messages.length === 0) {
        return null;
    }

    const parseMessageContent = (description) => {
        if (!description) return { mainText: '', bulletPoints: [] };

        const lines = description.split(/[\r\n]+/).filter(line => line.trim());

        if (lines.length === 0) return { mainText: description, bulletPoints: [] };

        const mainText = lines[0];

        const bulletPoints = lines.slice(1)
            .map(line => line.trim())
            .filter(line => line.length > 0)
            .map(line => {
                const cleanedLine = line.replace(/^[•\-*▪◦→‣⁃]\s*/, '').trim();
                return cleanedLine.replace(/^\d+[\.\)]\s*/, '').trim();
            })
            .filter(point => point.length > 0);

        return { mainText, bulletPoints };
    };

    return (
        <Grid size={{ xs: 12 }}>
            {!overviewScreen && (
                <Typography variant="body2" fontWeight="bold" marginBottom={2}>
                    Hotel Messages
                </Typography>
            )}

            <Grid container spacing={2}>
                {messages
                    .map((message, index) => {
                    const { mainText, bulletPoints } = parseMessageContent(message.Description);
                    if (!mainText && bulletPoints.length === 0) return null;

                    return (
                        <Grid size={{ xs: 12 }} key={message.Id || index}>
                            <Box
                                sx={{
                                    backgroundColor: theme.palette.background.primary,
                                    borderLeft: '4px solid',
                                    borderColor: 'success.main',
                                    borderRadius: 1,
                                    padding: 2,
                                    transition: 'all 0.2s',
                                }}
                            >
                                {/* Main Message */}
                                {mainText && (
                                    <Box display="flex" alignItems="flex-start" gap={1}>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: 600,
                                                color: 'text.primary',
                                                flex: 1,
                                                lineHeight: 1.6
                                            }}
                                        >
                                            {mainText}
                                        </Typography>
                                    </Box>
                                )}

                                {/* Bullet Points */}
                                {bulletPoints.length > 0 && (
                                    <Box
                                        component="ul"
                                        sx={{
                                            m: 0,
                                            mt: mainText ? 1.5 : 0,
                                            pl: 3.5,
                                            listStyle: 'none'
                                        }}
                                    >
                                        {bulletPoints.map((point, idx) => (
                                            <Box
                                                component="li"
                                                key={idx}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                    mb: idx < bulletPoints.length - 1 ? 1.2 : 0
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: 6,
                                                        height: 6,
                                                        borderRadius: '50%',
                                                        backgroundColor: 'success.main',
                                                        mt: 1.1,
                                                        mr: 1.5,
                                                        flexShrink: 0
                                                    }}
                                                />
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: 'text.secondary',
                                                        lineHeight: 1.6
                                                    }}
                                                >
                                                    {point}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                )}
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>
        </Grid>
    );
};

export default EntityMessagesDetails;